module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice messageNotice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "messagePadding",
    staticStyle: {
      "height": "350px",
      "overflow-y": "auto"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.params.noticeText))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.params.noticeSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footerNotice"
  }, [(_vm.params.sendType != 1) ? _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "60px",
      "vertical-align": "top"
    }
  }, [_vm._v("发送人:\n        ")]) : _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "80px",
      "vertical-align": "top"
    }
  }, [_vm._v("发送班级：\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.params.sender))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.params.time))])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41f3d0f3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/message.vue
// module id = 1191
// module chunks = 1